import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfService = () => {
  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-12 max-w-4xl mx-auto">
          <h1 className="text-4xl font-black text-gray-900 dark:text-white mb-8">
            Términos y Condiciones de Servicio
          </h1>
          
          <div className="prose dark:prose-invert max-w-none">
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Última actualización: 7 de diciembre de 2025
            </p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">1. Aceptación de los Términos</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Al acceder y utilizar la plataforma GPT-JDP ("el Servicio"), usted acepta estar sujeto a estos Términos y Condiciones. Si no está de acuerdo con ellos, debe suspender inmediatamente el uso del Servicio.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">2. Definiciones</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-2">
                <strong>"Plataforma" o "Servicio":</strong> el ecosistema completo GPT-JDP, incluyendo modelos de IA, módulos, interfaces web, APIs y sistemas de crédito.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-2">
                <strong>"Usuario":</strong> cualquier persona que acceda o utilice el Servicio.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-2">
                <strong>"Contenido generado":</strong> todo texto, imagen, audio, código o material producido mediante el Servicio.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                <strong>"Planes":</strong> las suscripciones ofrecidas por GPT-JDP.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">3. Descripción del Servicio</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                GPT-JDP es una plataforma de inteligencia artificial que ofrece:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Acceso a modelos IA avanzados (GPT-4, GPT-5, Claude, Gemini, etc.).</li>
                <li>Generación de texto, imágenes y recursos multimedia.</li>
                <li>Chatbots conversacionales automatizados.</li>
                <li>Módulos especializados (Legal, Contabilidad, Ciberseguridad, Creativo, Técnico).</li>
                <li>Sistema de créditos para operaciones específicas.</li>
                <li>Panel de control, historial y analítica básica de uso.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                La disponibilidad de modelos y funciones puede variar según el plan contratado.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">4. Registro y Cuenta</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                4.1. Para utilizar el Servicio, debe registrarse con información verídica, completa y actualizada.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                4.2. Usted es responsable de mantener la confidencialidad de sus credenciales.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                4.3. Cualquier actividad realizada desde su cuenta se presume realizada por usted.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                4.4. Debe notificar inmediatamente cualquier acceso no autorizado.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">5. Planes, Pagos y Renovaciones</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                5.1. El Servicio opera con planes de suscripción mensual y anual.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                5.2. Los pagos se procesan mediante plataformas externas seguras (Stripe, PayPal).
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                5.3. Las suscripciones se renuevan automáticamente a menos que sean canceladas antes del periodo de cobro.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                5.4. Los precios pueden cambiar previa notificación con 30 días de anticipación.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                5.5. No se realizan reembolsos por meses utilizados parcialmente.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">6. Sistema de Créditos</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                6.1. Los créditos permiten ejecutar funciones específicas de IA.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                6.2. Los créditos no utilizados se mantienen mientras la cuenta esté activa.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                6.3. Los créditos no son reembolsables ni transferibles.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                6.4. GPT-JDP puede ajustar el costo en créditos de las funciones según evolución tecnológica.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">7. Uso Aceptable del Servicio</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                El Usuario se compromete a NO utilizar el Servicio para:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Actividades ilegales, fraudulentas o maliciosas.</li>
                <li>Crear contenido que infrinja derechos de terceros.</li>
                <li>Violaciones a la propiedad intelectual.</li>
                <li>Generar desinformación, deepfakes, suplantación de identidad o manipulación digital.</li>
                <li>Ataques, ingeniería inversa, scraping o extracción masiva de datos.</li>
                <li>Reventa, sublicencia o redistribución no autorizada de la plataforma.</li>
                <li>Crear competidores directos usando la plataforma.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                GPT-JDP puede suspender cuentas por violaciones de esta política.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">8. Propiedad Intelectual</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                8.1. El contenido generado por usted mediante el Servicio es de su propiedad, salvo que infrinja leyes o derechos de terceros.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                8.2. GPT-JDP conserva todos los derechos sobre su tecnología interna, modelos, código, diseño y arquitectura del sistema.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                8.3. No se concede ninguna licencia sobre el backend, modelos o infraestructura salvo la estrictamente necesaria para usar la plataforma.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">9. Datos, Privacidad y Seguridad</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                9.1. GPT-JDP procesa datos conforme a la legislación chilena y estándares internacionales (GDPR cuando corresponda).
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                9.2. No se deben ingresar datos sensibles:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>información médica confidencial,</li>
                <li>datos financieros completos,</li>
                <li>información personal de terceros,</li>
                <li>contraseñas o claves privadas.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                9.3. El Usuario es responsable de los datos que ingrese en el sistema.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">10. Limitación de Responsabilidad</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                10.1. El Servicio se ofrece "tal cual" y "según disponibilidad".
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                10.2. GPT-JDP no garantiza la precisión del contenido generado por IA.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                10.3. No se permite utilizar contenido generado por la plataforma como:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>dictamen legal,</li>
                <li>diagnóstico médico,</li>
                <li>asesoría financiera profesional.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                10.4. La responsabilidad total de GPT-JDP queda limitada al monto pagado en los últimos 12 meses.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">11. Cancelación y Terminación</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                11.1. Usted puede cancelar su suscripción en cualquier momento.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                11.2. Al cancelar, mantiene acceso hasta el final del periodo pagado.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                11.3. GPT-JDP puede suspender o eliminar cuentas que violen estos términos.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">12. Modificaciones</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                GPT-JDP puede actualizar estos términos y notificará cambios importantes con al menos 30 días de anticipación.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">13. Ley Aplicable y Jurisdicción</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Estos términos se rigen por las leyes de Chile.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Cualquier conflicto será resuelto ante los tribunales ordinarios de Santiago de Chile.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">14. Contacto</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Email: ceo@gpt-jdp.com
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Sitio web: www.gpt-jdp.com
              </p>
            </section>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default TermsOfService;